import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import "./zoom-controls.scss";

export interface IZoomControlsProps {
  zoomScale: number;
  onZoomChange: (scale: number) => void;
}

export interface IZoomControlsState {}

class ZoomControls extends PureSdComponent<IZoomControlsProps & IWithSDProps, IZoomControlsState> {
  constructor(props: IZoomControlsProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  handleZoomIn = () => {
    const newScale = Math.min(this.props.zoomScale + 0.1, 2);
    this.props.onZoomChange(Number(newScale.toFixed(1)));
  };

  handleZoomOut = () => {
    const newScale = Math.max(this.props.zoomScale - 0.1, 1);
    this.props.onZoomChange(Number(newScale.toFixed(1)));
  };

  handleZoomReset = () => {
    this.props.onZoomChange(1);
  };

  render() {
    const zoomPercentage = Math.round(this.props.zoomScale * 100);

    return (
      <div className="kuika_report-zoom-controls">
        <div className="kuika_zoom-button-group">
          <KuikaButton
            type="secondary"
            size="sm"
            isIcon
            onClick={this.handleZoomOut}
            disabled={this.props.zoomScale <= 1}
            className="kuika_zoom-button"
            data-testid="zoomOutButton"
          >
            <KuikaSvg name="minus" width={14} height={14} />
          </KuikaButton>
          <div className="kuika_zoom-display" data-testid="zoomDisplay">
            {zoomPercentage}%
          </div>
          <KuikaButton
            type="secondary"
            size="sm"
            isIcon
            onClick={this.handleZoomIn}
            disabled={this.props.zoomScale >= 2}
            className="kuika_zoom-button"
            data-testid="zoomInButton"
          >
            <KuikaSvg name="plus" width={14} height={14} />
          </KuikaButton>
          <KuikaButton
            type="secondary"
            size="sm"
            isIcon
            onClick={this.handleZoomReset}
            className="kuika_zoom-button"
            data-testid="zoomResetButton"
          >
            <KuikaSvg name="refresh" width={14} height={14} />
          </KuikaButton>
        </div>
      </div>
    );
  }

  checkNeedRender = (): boolean => {
    return false;
  };
}

const zoomControls = withSD<IZoomControlsProps>(ZoomControls);
export { zoomControls as ZoomControls };
